/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SLAUnitType } from "~/models";

export function displaySlaUnitType(value: string) {
  switch (value) {
    case SLAUnitType.BEST_EFFORT:
      return "Best Effort";
    case SLAUnitType.CUSTOM:
      return "Custom";
    case SLAUnitType.VALUE_RANGE:
      return "Value Range";
    default:
      return "-";
  }
}
